import type { FunctionComponent } from 'react'
import React from 'react'
import { Accordion, AccordionItem, Grid, GridItem } from '@which/seatbelt'
import type { ArticleUIData } from '@which/shared'

import { articleBodyRenderer } from '../../renderers/article-body-renderer'

export const AccordionSection: FunctionComponent<Props> = ({ articles = [] }) => {
  if (!articles?.length) {
    return null
  }

  return (
    <Grid className="w-page-wrapper">
      <GridItem span={{ medium: 8, large: 8 }} columnStart={{ medium: 3, large: 3 }}>
        <Accordion data-testid="accordion-section">
          {articles.map(({ id, title, articleBodyTemplate }, index) => (
            <AccordionItem
              renderOpen={index === 0}
              key={id}
              label={title}
              content={articleBodyRenderer(articleBodyTemplate)}
            />
          ))}
        </Accordion>
      </GridItem>
    </Grid>
  )
}

///////// IMPLEMENTATION /////////

type Props = {
  articles: {
    id: number
    title: string
    articleBodyTemplate: ArticleUIData[]
  }[]
}
